var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.form.identificacao)?_c('Cadastrado',{attrs:{"form":_vm.form.identificacao}}):_c('Desconhecido',{attrs:{"form":_vm.form.desconhecido,"model":_vm.model}})
}
var staticRenderFns = []

export { render, staticRenderFns }